// Theme is already being used by packages as a named export.
import * as BREAKPOINTS from '../dsm/breakpoints';
import * as DURATIONS from '../dsm/durations';
import * as ELEVATION from '../dsm/elevation';
import * as EMAIL from '../dsm/email';
import * as MEDIA_TYPES from '../dsm/media-types';
import * as OUTLINE from '../dsm/outline';
import * as SHAPE from '../dsm/shape';
import * as SPACING from '../dsm/spacing';
import { getTypography } from '../dsm/typography';
export const getMediaQueryString = (mediaQuery, mediaTypes, breakpoints) => {
  const {
    mediaType,
    breakpoint
  } = mediaQuery;
  return ['@media', [mediaType ? mediaTypes[mediaType] : '', breakpoint ? breakpoints[breakpoint] : ''].filter(Boolean).join(' and ')].join(' ');
};
export const basicTheme = {
  BREAKPOINTS,
  MEDIA_TYPES,
  DURATIONS,
  EMAIL,
  TYPOGRAPHY: getTypography(),
  SHAPE,
  ELEVATION,
  SPACING,
  OUTLINE,

  mediaBreakpoint(breakpoint) {
    return `@media ${this.BREAKPOINTS[breakpoint]}`;
  },

  mediaQuery(args) {
    return getMediaQueryString(args, this.MEDIA_TYPES, this.BREAKPOINTS);
  }

};
export { getTypography };